import { useQuery } from 'react-query';

import AssessmentService from 'App/services/AssessmentService';

function useFetchAssessmentCategories() {
    return useQuery(['assessmentCategories'], AssessmentService.getAssessmentCategories, {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssessmentCategories;
